import { render, staticRenderFns } from "./CreateSettlementDriverNoKasbon.vue?vue&type=template&id=65f4d1f9"
import script from "./CreateSettlementDriverNoKasbon.vue?vue&type=script&lang=js"
export * from "./CreateSettlementDriverNoKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports